import React from 'react'
import { useInView } from 'react-intersection-observer'
import { useSelector } from 'react-redux'

import trads from '../intl/trads.json'

import transformLink from '../utils/transformLink'
import PageCard from './cards/pageCard'
import NewsCard from './cards/newsCard'

import semiroundShape from '../icons/semiround-shape.svg'

const PushContent = ({data, type, autoItems}) => {
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  // redux lang
  const lang = useSelector(state => state.lang)

  let pushs = data

  if(data === null || data === undefined) {
    pushs = (autoItems.nodes) ? autoItems.nodes : autoItems
  }

  return (
    <>
    { pushs.length > 0 && pushs.filter(push => push !== undefined).length > 0 &&
      <section className={`push-content relative ${inView ? 'has-anim' : ''}`} ref={ref}>
        <svg className="absolute push-content__deco icon-orange" width="96" height="113">
          <use xlinkHref={semiroundShape.url} />
        </svg>
        <div className="push-content__header push-content__strat">
          <h2 className="title title-slice pb-8 scroll-anim-el">
            { trads[lang].readAlso }
            <span className="font-normal block">{ trads[lang].readAlso2 }</span>
          </h2>
        </div>

        <div className="push-content__content push-content__strat">
          <div className="row">
            {pushs.map((item, i) => {
              let datas, page, url, title
              let chapo = null
              let ctaLabel = null
              let mainImage = null
              let mainTag = ''
              
              if(data !== null && data !== undefined) {
                datas = (item.fields) ? item.fields : item
                page = (item.fields) ? datas.page.fields : datas.page

                let cta = transformLink(datas.page, false, false)
                url = cta.url

                if (datas.chapo) {
                  chapo = (datas.chapo.chapo) ? datas.chapo.chapo : datas.chapo
                }
                title = page.title

                mainTag = page.mainTag ? page.mainTag.title : ''

                if (page.mainImage || (page.fields && page.fields.mainImage)) {
                  mainImage = (page.fields) ? page.fields.mainImage : page.mainImage
                }

                ctaLabel = datas.ctaLabel ? datas.ctaLabel : trads[lang].learnMore
              } else {
                title = (item.fields) ? item.fields.title : item.title
                let cta = transformLink(item, false, false)
                url = cta.url
                
                item = item.field ? item.fields : item

                if (item.mainImage || (item.fields && item.fields.mainImage)) {
                  mainImage = item.fields ? item.fields.mainImage : item.mainImage
                }

                ctaLabel = trads[lang].learnMore
                mainTag = item.mainTag ? item.mainTag.title : ''
              }

              return (
                <div className={`col-12 md-col-4 flex mb-8 md:mb-0 scroll-anim-el scroll-anim-el--${i + 2}`} key={i}>
                  { type === 'news'
                    ? <NewsCard news={item} />
                    : <PageCard mainTag={mainTag} chapo={chapo} ctaLabel={ctaLabel} url={url} title={title} mainImage={mainImage} />
                  }
                </div>
              ) 
            })}
          </div>
        </div>
      </section>
    }
    </>
  )
}

export default PushContent
